export interface MultiSelectOptionViewModel<TValue, TData = unknown> {
  value: TValue;
  label: string;
  searchLabel?: string;
  data?: TData;
  disabled?: boolean;
  alwaysShownInSearchResult?: boolean;
}

export interface MultiSelectOptionWithSelectedViewModel<TValue, TData = unknown> extends MultiSelectOptionViewModel<TValue, TData> {
  selected: boolean;
}

export const ALL_OPTION = 'ALL';
